import { TEncodingErrorFactory } from '../types';

export const createEncodingError: TEncodingErrorFactory = () => new DOMException('', 'EncodingError');
